<script>
    export default {
        name: "MediaCardTitle",
        props: {
            position: String,
        },
        computed: {
            computeClassNames() {
                return [`media-card__title--${this.position}`];
            },
        },
    };
</script>

<template>
    <div class="media-card__title" :class="computeClassNames">
        <slot></slot>
    </div>
</template>

<style lang="scss">
    .media-card__title {
        font-size: 14px;
        font-weight: var(--media-title-weight);
        line-height: 20px;
        color: var(--media-title);
        padding-right: 3px;
        transition: 0.3s ease-in-out color;

        &:hover {
            color: var(--media-title-hover);
        }
    }

    .media-card__title--inside {
        position: absolute;
        left: 5px;
        right: 5px;
        bottom: 10px;
        color: var(--media-title);
        padding-right: 3px;
    }
</style>
